module.exports = __webpack_public_path__ + "static/media/WordsHavePower_p1.d007a4dc.jpg";